import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isPresent } from '@shared/utils/helpers';

@Pipe({ name: 'abs' })
export class AbsPipe implements PipeTransform {
    transform(value: number): number {
        if (!isPresent(value)) {
            return value;
        }

        return Math.abs(value);
    }
}
